export const RADIO_TYPE = 'RADIO';
export const CHECKBOX_TYPE = 'CHECKBOX';
export const CHECKBOX_BASED_BUTTON_TYPE = 'CHECKBOX BASED BUTTON';
export const MULTI_SELECT_TYPE = 'MULTI SELECT';
export const TODAY_TYPE = 'Today';
export const YESTERDAY_TYPE = 'Yesterday';
export const LAST_DAYS_TYPE = 'Last 7 Days';
export const LAST_MONTH_TYPE = 'Last month';
export const CUSTOM_RANGE_TYPE = 'Custom Range';